import { render, staticRenderFns } from "./Wallpapers.vue?vue&type=template&id=596854d4&scoped=true&"
import script from "./Wallpapers.vue?vue&type=script&lang=js&"
export * from "./Wallpapers.vue?vue&type=script&lang=js&"
import style0 from "./Wallpapers.vue?vue&type=style&index=0&id=596854d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596854d4",
  null
  
)

export default component.exports